module.exports = __webpack_public_path__ + "static/media/payment.f70cde0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/DetailPage/payment.png
// module id = 1226
// module chunks = 1